module.exports = __webpack_public_path__ + "img/empty.0f843925.png";